<template>
  <div>
    <div v-if="show" class="popup-overlay" @click="closePopup">
      <div class="popup-content" @click.stop :class="{ 'popup-disabled': loading }">
        <div class="popup-head">
          <div class="popup-image-mob"></div>
          <button class="close-button" @click="closePopup" :disabled="loading">&times;</button>
        </div>
        <div class="popup-body">
          <div class="popup-text">
            <!-- <p class="pop-desc">جرّب القوة... وحسّها بنفسك!</p> -->
            <h4 class="popup-heading-four">رجعة مدارس غير مع مونجلش!</h4>
            <h2 class="popup-heading-two">احصل على شهرين<br class="max-sm:hidden " /> مجانيين<br
                class="hidden max-sm:flex" /> وخصم 1800 ريال</h2>
            <p class="pop-desc2">العرض الأقوى لتعليم طفلك الإنجليزية يبدأ الآن مع مونجلش.</p>
            <p class="pop-desc2-mob">العرض الأقوى لتعليم طفلك<br /> الإنجليزية يبدأ الآن مع مونجلش.</p>

            <form @submit.prevent="register" class="pop-form" :class="{ 'form-disabled': loading }">
              <div class="inline-group">
                <div class="form-pop">
                  <label for="fullName" class="pop-label">الاسم الكامل</label>
                  <input type="text" class="pop-input" id="fullName" placeholder="الاسم الكامل" v-model="fullName"
                    required :disabled="loading" />
                </div>
                <div class="form-pop">
                  <label for="phoneNumber" class="pop-label">كود الدولة متبوعا برقم الواتساب</label>
                  <vue-tel-input class="pop-input" v-model:phoneNumber="phoneNumber" v-model:country="country"
                    @input="onPhoneInput" @validate="onPhoneValidate" mode="international"
                    :preferred-countries="['SA', 'KW', 'AE', 'QA', 'EG', 'JO', 'OM', 'YE', 'BH', 'IQ']"
                    defaultCountry="SA" :inputOptions="inputOptions"
                    :inputprops="{ name: 'phoneNumber', id: 'phoneNumber', required: true, placeholder: 'رقم الهاتف' }"
                    :disabled="loading" />
                </div>
              </div>
              <div class="form-pop email-form-pop">
                <label for="email" class="pop-label">البريد الإلكتروني</label>
                <input type="email" class="pop-input" id="email" placeholder="example@email.com" v-model="email"
                  required :disabled="loading" />
              </div>
              <input type="hidden" v-model="fullPhoneNumber" />

              <!-- <div class="text-start text-[#555555]">لا تفوت الفرصة واشترك الآن</div> -->

              <button type="submit" class="pop-btn" :disabled="loading">اشترك الآن</button>
            </form>
            <div v-if="loading" class="spinner-overlay">
              <div class="spinner"></div>
            </div>
            <p class="pop-bottom">تُحفظ التفاصيل الشخصية وتستخدم فقط فيما يتعلق بطلبك <br class="hidden-mob" /> فقط.
              يُرجى قراءة .
              <a href="/ar/terms-and-conditions">شروط الاستخدام</a> <span class="hidden-mob">لمزيد من المعلومات.</span>
            </p>
          </div>
          <div class="popup-image"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { VueTelInput } from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';

export default {
  props: {
    show: Boolean,
  },
  emits: ['close'],
  components: {
    VueTelInput,
  },
  data() {
    return {
      // showPopup: false,
      fullName: '',
      email: '',
      phoneNumber: '',
      country: null,
      inputOptions: {
        hiddenInput: true,
      },
      isValidPhone: false,
      fullPhoneNumber: '',
      loading: false,
    };
  },
  methods: {
    onPhoneInput(formattedNumber, phoneObject) {
      if (phoneObject && phoneObject.number) {
        console.log('Phone Input:', formattedNumber, phoneObject);
        this.fullPhoneNumber = phoneObject.number;
      }
    },
    onPhoneValidate(isValid, phoneObject) {
      console.log('Validation Result:', isValid);
      this.isValidPhone = isValid;

      if (isValid && phoneObject && phoneObject.number) {
        this.fullPhoneNumber = isValid.number;
      } else if (!isValid) {
        console.warn('Phone number is not valid.');
      }
    },
    closePopup() {
      // this.showPopup = false;
      this.$emit('close');
      sessionStorage.setItem('popupShown', 'true');
    },
    register() {
      if (!this.fullPhoneNumber) {
        console.error('Phone number is missing or invalid.');
        return;
      }

      // Start loading
      this.loading = true;

      const payload = {
        name: this.fullName,
        email: this.email,
        phone: this.fullPhoneNumber,
      };

      let headers = { 'Content-Type': 'application/json' };
      axios.post(`/api/free-session-forms`, payload, { headers })
        .then(response => {
          const data = response.data;
          if (response.status === 201) {
            console.log('Form submitted successfully:', data);
            this.formSubmitted = true;
            this.closePopup();
          } else {
            console.error('Error in response:', data.message || 'Unknown error');
          }
        })
        .catch(error => {
          console.error('Error submitting form:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  direction: rtl;
  font-family: 'DIN Next LT Arabic-n', sans-serif;
  overflow: auto;
}

.popup-content {
  background: white;
  display: flex;
  max-width: 990px;
  width: 100%;
  max-height: 100%;
  border-radius: 20px;
  position: relative;
}

.popup-head {
  display: flex;
}

.popup-body {
  display: flex;
  width: 100%;
}

.popup-text {
  flex: 1;
  padding: 50px;
  text-align: start;
  line-height: 1.5;
  margin-top: 10px;
}

.popup-heading-four {
  font-size: 22px;
  font-weight: 400;
  color: #555555;
  margin-bottom: 20px;
  line-height: 1.1;
}

.popup-heading-two {
  font-size: 44px;
  font-weight: 700;
  color: #ff6f00;
  margin-bottom: 10px;
  line-height: 1.1;
}

.pop-card {
  background: linear-gradient(45deg, #ff9442, #ff6f00);
  color: white;
  border-radius: 25px 0 0 25px;
  margin-inline-start: -30px;
  padding-inline-start: 30px;
  margin-top: 10px;
  padding-top: 8px;
  padding-bottom: 16px;
}

.pop-card p {
  line-height: 90%;
  font-size: 1.75em;
  font-weight: 500;
}

.pop-desc,
.pop-desc2 {
  line-height: normal;
  font-size: 22px;
  font-weight: 700;
  margin-top: 20px;
  margin-bottom: 0px;
  color: #165E84;
}

.pop-desc3 {
  font-size: 20px;
  font-weight: 900;
  color: #165E84;
}

.pop-sub-desc3 {
  font-size: 24px;
  font-weight: 700;
  color: #165E84;
}

.pop-desc span {
  color: #ff6f00;
}

.pop-desc2-mob {
  display: none;
}

.popup-image {
  flex: 1;
  background-image: url('https://monglish.b-cdn.net/home/popup/popup-6-levels-ar.png');
  background-size: cover;
  background-position: center;
  border-radius: 20px 0 0 20px;
  padding: 0;
  width: 100%;
}

.popup-image-mob {
  display: none;
}

.close-button {
  position: absolute;
  top: 0.8rem;
  right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding-bottom: 10px;
  border: 2px solid #165E84;
  background: transparent;
  color: #165E84;
  font-size: 2rem;
  font-weight: 400;
  cursor: pointer;
}

form div {
  margin-bottom: 1.25em;
  /* adjusted to relative unit */
}

.pop-form {
  text-align: right;
  direction: rtl;
}

.form-pop:first-child .pop-input {
  padding-block: 0.8em;
}

.pop-input {
  width: calc(100% - 1.25em);
  padding: 0.625em;
  margin: 0;
  border-radius: 10px;
  background-color: #f3f7ff;
  border: none;
}

form .form-pop {
  margin-bottom: 10px;
}

form .email-form-pop {
  margin-bottom: 20px;
}

.email-form-pop .pop-input {
  padding-block: 0.8em;
}

.pop-label {
  display: block;
  margin-right: 0.75em;
  text-align: right;
  font-weight: 500;
  color: #bababa;
  margin-top: 0;
  /* Consistent spacing */
  margin-bottom: 5px;
  /* Added spacing below label */
}

.pop-bottom {
  color: #979797;
  font-family: 'DIN Next LT Arabic-n';
  font-weight: 500;
  font-size: 16px;
  margin-top: 20px;
  /* Consistent margin */
}

.pop-bottom a {
  color: #165e84;
}

.inline-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.inline-group .form-group {
  width: 48%;
}

.pop-btn {
  background: linear-gradient(45deg, #ff9442, #ff6f00);
  color: white;
  border: none;
  padding: 0.25rem 0.25rem;
  cursor: pointer;
  border-radius: 20px;
  width: 100%;
  font-size: 1.5em;
  font-family: 'DIN Next LT Arabic', sans-serif;
}

.pop-bottom {
  color: #979797;
}

/* Small screens (max-width: 768px) */
@media (max-width: 1000px) {
  .popup-overlay {
    align-items: center;
  }

  .popup-content {
    max-width: 90%;
    flex-direction: column;
  }

  .popup-head {
    display: flex;
  }

  .popup-text {
    padding: 1.2em;
    padding-top: 0;
  }

  .popup-heading-two {
    text-align: center;
    margin-bottom: 5px;
    font-size: 1.5em;
    line-height: normal;
  }

  .popup-heading-four {
    font-size: 1.2em;
    margin-bottom: 5px;
    text-align: center;
  }

  .pop-card {
    margin-inline-start: -1.5em;
  }

  .pop-card p {
    font-size: 1.25em;
  }

  .pop-desc {
    margin-top: 0;
    text-align: center;
  }

  .pop-desc2,
  .pop-desc3,
  .pop-sub-desc3 {
    display: none;
  }

  .pop-desc2-mob {
    display: block;
    text-align: center;
    color: #165E84;
    font-size: 20px;
    font-weight: 400;
    margin-top: 10px;
    margin-bottom: 0;
    line-height: normal;
    background: none;
    border-radius: 0;
    padding: 0;
  }

  .popup-image {
    display: none;
  }

  .popup-image-mob {
    display: flex;
    background-image: url('https://monglish.b-cdn.net/home/popup/WhatsApp%20Image%202025-08-27%20at%2019.14.15_95bc8038.jpg');
    background-size: cover;
    background-position: center;
    border-radius: 20px;
    width: 100%;
    height: 100%;
    padding: 5rem;
  }

  .close-button {
    top: -50px;
    right: 10px;
    color: #fff;
    border-color: #fff;
  }

  .pop-label {
    font-size: smaller;
  }

  .pop-input {
    width: calc(100% - 1em);
  }

  form .form-pop {
    margin-bottom: 5px;
  }

  form .email-form-pop {
    margin-bottom: 10px;
  }

  .pop-btn {
    padding: 0.75em 1em;
    font-size: 1.25em;
    margin-inline: 0;
    width: 100%;
  }

  .inline-group {
    align-items: center;
  }

  .hidden-mob {
    display: none;
  }
}

.vue-tel-input {
  direction: ltr;
}

.vue-tel-input:focus-within {
  box-shadow: unset !important;
}

/* loading spinner */
.popup-disabled {
  pointer-events: none;
  /* Disable interaction while loading */
}

.form-disabled {
  pointer-events: none;
  /* Disable form interaction while loading */
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.5);
  /* Gray background with 0.8 opacity */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  /* Ensure spinner is above everything else */
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #ffe100;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* loading spinner */
</style>